import { jsx as r } from "react/jsx-runtime";
import { Tooltip as m } from "../tooltip/index.mjs";
const i = (o) => /* @__PURE__ */ r(m, { ...o, mode: "click" });
export {
  i as Popover
};
